import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Form } from 'react-bootstrap';
import close from '../Asset/close.svg';
import { MultiSelect } from "react-multi-select-component";
import Alert from './Alert';
import Table from './tables/mapDashTable';
import SelectSearch, { fuzzySearch } from "react-select-search";
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Dash_Group_Mapping() {
  let userObj = getUserInfo();
  let [sessOut, setSessOut] = useState(false);
  let [malert, setAlert] = useState({
    msg: "",
    status: false
  });

  //for multiselect
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    let arr = [];
    selected.map(e => (arr.push(e.value)));
    setDashboardGroupMapping({ ...dashboardGroupMapping, userID: arr });
  }, [selected])
  //for multiselect

  const [accounts, setAccounts] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setErrorMsg({});
    setShow(false)
    setDashboardGroupMapping({
      userID: [],
      groupID: "",
      isActive: true,
      opType: "",
      apiUid: [],
      accountID: "",
    });
    setUsers([]);
    setSelected([]);
    setDashboardGroupList([]);
  };
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  let [showUsers, setShowUsers] = useState(false);
  const handleShow = () => {
    setDashboardGroupMapping({ ...dashboardGroupMapping, opType: "add" })
    setShow(true);
  }
  const handleShow2 = () => {
    setShow2(true);
  }
  useEffect(() => {
    getUserDashboardGroupList();
    getAccounts();
  }, []);
  let [dashboardGroupMapping, setDashboardGroupMapping] = useState({
    userID: [],
    groupID: "",
    isActive: true,
    opType: "",
    apiUid: [],
    accountID: "",
  })
  let [dashboardGroupList, setDashboardGroupList] = useState([]);

  const valueRenderer = (selected) => {
    let label = [];
    selected.map((item) =>
      label.push(item.label)
    )
    if (selected.length === 0) {
      return "Select"
    }
    else {
      return label.toString();
    }
  };

  function getAccounts() {
    fetch(environment.baseUrl + 'getAccountMasterList?', {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((res) => {
      res.json().then((resp) => {
        if (resp.code === 200) {
          setAccounts(resp.data.result);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setAccounts([]);
        }
      })
    })
  }
  function getGroupByAccount(accID) {
    fetch(environment.baseUrl + "getGroupByAccount?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": accID
      })
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code === 200) {
            let temp = []
            resp.data.result.map((item) =>
              temp.push({
                accountiD: item.accountID,
                groupName: item.groupName,
                groupID: item.groupID
              })
            )
            setDashboardGroupList(temp);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setDashboardGroupList([])
          }
        })
      })
  }
  let [users, setUsers] = useState([])
  const [userdashboardGroupList, setUserDashboardGroupList] = useState([]);
  function getUserDashboardGroupList() {
    fetch(environment.baseUrl + 'getUserDashboadgroupMapping?', {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((res) => {
      res.json().then((resp) => {
        if (resp.code === 200) {
          let tempArr = [];
          resp.data.map((item) =>
            tempArr.push({
              groupName: item[0].groupName,
              accountName: item[0].accountName,
              user: item[0].user
            })
          )
          setUserDashboardGroupList(tempArr);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setUserDashboardGroupList([]);
        }
      })
    })
  }


  function getDashboardGroupList() {
    fetch(environment.baseUrl + 'GetDashboardGroupMapping?', {

    }).then((res) => {
      res.json().then((resp) => {
        let temp = []
        resp.data.map((item) =>
          temp.push({
            accountiD: item[0].dashboard[0].accountiD,
            groupName: item[0].dashboard[0].groupName,
            groupID: item[0].dashboard[0].groupID
          })
        )
        setDashboardGroupList(temp);
      })
    })
  }

  function getGroups(e) {
    setDashboardGroupMapping({ ...dashboardGroupMapping, [e.target.name]: e.target.value });
  }

  function getDashboardGroupMappingForm(e) {
    if (e) {
      setDashboardGroupList([]);
      setUsers([]);
      setSelected([]);
      setDashboardGroupMapping({ ...dashboardGroupMapping, accountID: e, groupID: "", userID: [] });
      if (e != "") {
        getGroupByAccount(e);
        if (dashboardGroupMapping.opType == "edit") {
          getUserByAccID(e);
        }
        else {
          getFreeUserAccID(e);
        }
      }
    }
  }
  function getUserByAccID(accID) {
    fetch(environment.baseUrl + "getUserByAccID?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": accID,
        "userType": "account_user"
      })
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code === 200) {
            setUsers(resp.data.result);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setUsers([]);
          }
        })
      })
  }
  function getFreeUserAccID(accID) {
    fetch(environment.baseUrl + "excludedGroupUsers", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": accID
      })
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code === 200) {
            setUsers(resp.data.result);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setUsers([]);
          }
        })
      })
  }
  function saveDashboardGroupMappingForm() {
    if (dashboardGroupMapping.groupID != "" && dashboardGroupMapping.userID.length != 0) {
      fetch(environment.baseUrl + 'addUserDashboardMapping?', {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userObj.token
        },
        body: JSON.stringify({
          userID: dashboardGroupMapping.userID,
          groupID: dashboardGroupMapping.groupID,
          isActive: true,
        })
      }).then((res) => {
        res.json().then((resp) => {
          setAlert({
            msg: resp.msg,
            status: true
          })
          handleClose();
          if (resp.code == 200) {
            getUserDashboardGroupList();
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
        })
      })
    }
    else {
      setAlert({
        msg: "Please fill all details",
        status: true
      })
    }
  }
  let [currentUser, setCurrentUser] = useState([]);
  const showGroupUsers = useCallback((users) => {

    setCurrentUser(users);
    setShowUsers(true);
  }, [])
  function converForUi(obj) {
    let tarr = [];
    obj[0].user.map((item) =>
      tarr.push(item.firstName + " " + item.lastName)
    )
    return (
      {
        groupName: obj[0].user[0].groupName,
        accountName: obj[0].user[0].accountName,
        users: tarr.toString()
      }
    )
  }
  const editGroupMappingUser = useCallback((currentObj) => {
    let usArr = [], uid = [];
    currentObj.user.forEach(element => {
      uid.push(element.userID);
      usArr.push({ label: element.firstName + " " + element.lastName, value: element.userID })
    });
    setDashboardGroupMapping({ ...dashboardGroupMapping, groupID: currentObj.user[0].groupID, opType: "edit", apiUid: uid, accountID: currentObj.user[0].accountID })
    setSelected(usArr);
    getUserByAccID(currentObj.user[0].accountID);
    getGroupByAccount(currentObj.user[0].accountID);
    setShow(true);
  }, [])
  function setAddRemoveItem() {
    let removeItem = dashboardGroupMapping.apiUid.filter((o) => dashboardGroupMapping.userID.indexOf(o) === -1);
    let addItem = dashboardGroupMapping.userID.filter((o) => dashboardGroupMapping.apiUid.indexOf(o) === -1);
    return (
      {
        removeUserID: removeItem,
        addUserID: addItem
      }
    )
  }
  function updateUserDashboardMapping() {
    let obj = setAddRemoveItem();
    fetch(environment.baseUrl + 'updateUDGM', {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        groupID: dashboardGroupMapping.groupID,
        addUserID: obj.addUserID,
        removeUserID: obj.removeUserID
      })
    }).then((res) => {
      res.json().then((resp) => {
        setAlert({
          msg: resp.msg,
          status: true
        })
        handleClose();
        if (resp.code == 200) {
          getUserDashboardGroupList();
          setUsers([]);
          setSelected([]);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
      })
    })
  }

  let [errorMsg, setErrorMsg] = useState({});
  function validate() {
    let errror = {};
    if (dashboardGroupMapping.accountID == "") {
      errror.accountID = "This field is required";
    }
    if (dashboardGroupMapping.groupID == "") {
      errror.groupID = "This field is required";
    }

    if (dashboardGroupMapping.opType != "edit" && dashboardGroupMapping.userID == "") {
      errror.userID = "This field is required";
    }
    setErrorMsg(errror);
    if (Object.keys(errror).length == 0) {
      if (dashboardGroupMapping.opType == "edit") {
        updateUserDashboardMapping();
      }
      else {
        saveDashboardGroupMappingForm();
      }
    }
    else {

    }
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Account Name ',
        accessor: 'accountName',
      },
      {
        Header: 'Dashboard Group ',
        accessor: 'groupName',
      },
      {
        Header: 'Users',
        accessor: 'user',
      },
      {
        Header: 'Action',
        accessor: 'action',
      },

    ],
    []
  )

  return (
    <div className='main-container'>
      <Alert obj={malert} />
      <SessionFun show = {sessOut}></SessionFun>
      <h4 className='main-heading'>Dashboard Group Mapping</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;
        <i className='fa fa-angle-right'></i></Link>&nbsp; Dashboard Group Mapping</p>

      <div className="row mt-3">
        <div className="col-sm-12 card-box-block">
          <Table columns={columns} data={userdashboardGroupList}
            editFun={editGroupMappingUser}
            dashGroups={showGroupUsers}
            handlemodal={handleShow} />
        </div>
      </div>

      <Modal show={show2} onHide={handleClose2} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title> Filters</Modal.Title>
          <button onClick={handleClose2} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>

          <div className="row text-center mt-3">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose2}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="add-btn btn-light lo-btn confirm-btn float-start" >
                Apply
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* for mapping and edit */}

      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>{dashboardGroupMapping.opType == "edit" ? "Edit Dashboard Group Mapping" : "Create New Dashboard Group Mapping"}</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Select Account<span style={{ color: "red" }}>*</span></Form.Label>
                <SelectSearch disabled={dashboardGroupMapping.opType == "edit" ? true : false}
                  options={accounts.map(e => ({ name: e.accountName, value: e.accountID }))}
                  value={dashboardGroupMapping.accountID}
                  onChange={getDashboardGroupMappingForm}
                  name="account"
                  placeholder="Select Account"
                  filterOptions={fuzzySearch}
                  search
                />
                <div className="row" style={{ marginTop: 40 }}>
                  <small className='red'>{errorMsg.accountID}</small>
                </div>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Select Group<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select className="textbox-back" name='groupID' value={dashboardGroupMapping.groupID} onChange={getGroups} disabled={dashboardGroupMapping.opType == "edit" ? true : false}>
                  <option value="">Select</option>
                  {
                    dashboardGroupList.map((item, index) =>
                      <option key={index} value={item.groupID}>{item.groupName}</option>
                    )
                  }
                </Form.Select>
                <small className='red'>{errorMsg.groupID}</small>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Select Users{dashboardGroupMapping.opType != "edit" ? <span style={{ color: "red" }}>*</span> : ""}</Form.Label>
                <MultiSelect
                  options={users.map(e => ({ label: e.firstName + " " + e.lastName, value: e.userID }))}
                  value={selected}
                  onChange={setSelected}
                  labelledBy="Select"
                  valueRenderer={valueRenderer}
                />
                <small className='red'>{errorMsg.userID}</small>
              </Form.Group>
            </div>
          </div>

          <div className="row text-center mt-3">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={validate}>
                {dashboardGroupMapping.opType == "edit" ? "Update" : "Submit"}
              </button>
            </div>
          </div>
          {/* </Form> */}
        </Modal.Body>
      </Modal>

      <Modal show={showUsers} onHide={() => setShowUsers(false)} centered backdrop="static" >
        <Modal.Header>
          <Modal.Title> Users Name</Modal.Title>
          <button onClick={() => setShowUsers(false)} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <table className="table">
            <thead className='table-secondary'>
              <tr>
                <th >User Name</th>
              </tr>
            </thead>
            <tbody>
              {
                currentUser.map((item, index) =>
                  //converForUi(item)
                  <tr key={index}>
                    <td>{item.firstName + " " + item.lastName}</td>
                  </tr>
                )
              }
            </tbody>
          </table>

          <div className="row justify-content-end mt-3">
            <button className="btn btn-outline-secondary lo-btn float-end"
              onClick={() => setShowUsers(false)}>
              Cancel
            </button>
          </div>
          {/* </Form> */}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Dash_Group_Mapping
